if (!customElements.get('fomo-feature-product')) {
  customElements.define(
    'fomo-feature-product',
    class FomoProductForm extends HTMLElement {
      constructor() {
        super();
        const id = this.id;
        this.radiocontainer = this.querySelector('#fomo-product-options');
        this.variantSelect = this.querySelector('input[name="id"]');
        this.targetGallery = this.dataset.mainimage;
        this.addRadioEventListeners();
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.radiocontainer.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      addRadioEventListeners(){
        const _this = this;
        const radios = this.radiocontainer.querySelectorAll('input[type=radio]');
        radios.forEach(function(radio){
          radio.addEventListener('change',function(event){_this.onVariantSelect(event,_this);});
        });
      }

      onVariantSelect(event,ffp){
        const radioName = Number(event.target.dataset.position);
        const value = event.target.value;
        ffp.updateVariantAvailablity(radioName,value);
        ffp.setVariantPicked();
      }

      updateVariantAvailablity(currentName,value){
        const nextRadioGroup = currentName + 1;
        const nextRadios = this.radiocontainer.querySelectorAll(`input[data-position="${nextRadioGroup}"]`);
        if(nextRadios && nextRadios.length > 0){
          const variants = this.getVariantData();
          const filtered = variants.filter(variant => variant[`option${currentName}`] == value && variant['available'] == true)
                                   .map(variant => variant[`option${nextRadioGroup}`]);
          const currentChecked = Array.from(nextRadios).find(r => r.checked || r.hasAttribute('checked'));
          let update = filtered.indexOf(currentChecked.value) == -1;
          console.log(update);
          nextRadios.forEach(function(radio){
            if(filtered.indexOf(radio.value) < 0){
              radio.disabled = true;
              radio.checked = false;
            } else {
              if(update){
                radio.checked = true;
                update = false
              }
              radio.disabled = false;
            }
          });
        }
      }

      setGallery(id,value){
        const images = document.querySelectorAll(`img[id='${id}']`);
        for(let i = 0,c=images.length;i<c;i++) images[i].style.display = value;
      }

      setVariantPicked(){
        const selectedRadios = Array.from(this.radiocontainer.querySelectorAll(`input[type=radio]:checked`));
        const variants = this.getVariantData();
        const selectedOptions = selectedRadios.map(function(radio){ 
          const result = {};
          result[`option${radio.dataset.position}`] = `${radio.value}`
          return result;
        }).reduce((x,y) => Object.assign(x,y),{});
        const keys = Object.getOwnPropertyNames(selectedOptions);
        let match = variants.find(variant => keys.every(key => variant[key] === selectedOptions[key]))
        
        const gallery = this.targetGallery ? document.querySelector(`#${this.targetGallery}`) : null; 
        const zoomContainer = document.querySelector('.zoom-image-container');
        const carousel = document.querySelector('.fomo-image-carousel');
        const thumbs = gallery ? document.querySelector('.fomo-product-gallery-thumbnail-container') ?? carousel : null
        if(gallery){
          this.setGallery(this.variantSelect.value,"none");
          const images = thumbs.querySelectorAll(`[data-variant="${this.variantSelect.value}"]`);
          for(let i = 0, c = images.length;i < c; i++ ){
            images[i].style.display = "none";
          }
        }
        if(zoomContainer){
          const images = zoomContainer.querySelectorAll(`[data-variant="${this.variantSelect.value}"]`);
          for(let i = 0, c = images.length;i < c; i++ ){
            images[i].style.display = "none";
          }
        }
        this.variantSelect.value = match.id;
        if(gallery){ 
          this.setGallery(this.variantSelect.value,"block");
          const images = thumbs.querySelectorAll(`[data-variant="${this.variantSelect.value}"]`);
          for(let i = 0, c = images.length;i < c; i++ ){
            images[i].style.display = "block";
          }
        }
        if(carousel){
          carousel.refresh();
        }
        if(zoomContainer){
          const images = zoomContainer.querySelectorAll(`[data-variant="${this.variantSelect.value}"]`);
          for(let i = 0, c = images.length;i < c; i++ ){
            images[i].style.display = "block";
          }
        }
        
        var event = new Event('updateVariant');
        this.variantSelect.dispatchEvent(event);
      }
    }
  );
}
if (!customElements.get('fomo-product-quantity')) {
  customElements.define(
    'fomo-product-quantity',
    class FomoProductQuantity extends HTMLElement {
      constructor() {
        super();
        this.minus = this.querySelector('button.minus');
        this.quantity = this.querySelector('input[name="quantity"]');
        this.add = this.querySelector('button.add');
        this.variantSelect = document.querySelector('input[name="id"]');
        this.addEventListeners();
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(document.querySelector('fomo-feature-product').querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      getVariant(id){
        const variants = this.getVariantData();
        const selectedVariant = variants.find(variant => variant.id == id);
        return selectedVariant;
      }

      addEventListeners(){
        const _this = this;
        this.minus.addEventListener('click',function(){_this.minusFN(_this);});
        this.add.addEventListener('click',function(){_this.addFN(_this);});
        this.quantity.addEventListener('change',function(event){_this.updateFN(event,_this);});
      }

      minusFN(fpq){
        const newNumber = Number(fpq.quantity.value) - 1;
        if(newNumber == 1){
          fpq.minus.disabled = true;
        }
        fpq.quantity.value = newNumber;
        var event = new Event('updatequantity');
        fpq.quantity.dispatchEvent(event);
      }

      addFN(fpq){
        const newNumber = Number(fpq.quantity.value) + 1;
        const selectedVariant = fpq.getVariant(fpq.variantSelect.value);
        fpq.minus.disabled = false;
        fpq.quantity.value = newNumber;
        if(selectedVariant.quantity_rule.max && selectedVariant.quantity_rule.max == newNumber){
          fpq.add.disabled = true;
        }
        var event = new Event('updatequantity');
        fpq.quantity.dispatchEvent(event);
      }

      updateFN(event,fpq){
        const selectedVariant = fpq.getVariant(fpq.variantSelect.value);
        const newValue = Number(event.target.value);
        if(selectedVariant.quantity_rule.max && selectedVariant.quantity_rule.max >= newValue){
          fpq.add.disabled = true;
          event.target.value = selectedVariant.quantity_rule.max;
        } else if (selectedVariant.quantity_rule.min && newValue <= selectedVariant.quantity_rule.min){
          fpq.remove.disabled = true;
          event.target.value = selectedVariant.quantity_rule.min;
        }
        var event = new Event('updatequantity');
        fpq.quantity.dispatchEvent(event);
      }
    }
  );
}

if (!customElements.get('fomo-product-price')) {
  customElements.define('fomo-product-price',class FomoProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.section = document.querySelector(`.${this.dataset.section}`);
      this.moneyformat =JSON.parse(this.dataset.moneyformat);
      this.quantity = this.section.querySelector('input[name="quantity"]');
      this.variantSelect = this.section.querySelector('input[name="id"]');
      this.addEventListeners();
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(document.querySelector('fomo-feature-product').querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    
    getVariant(id){
      const variants = this.getVariantData();
      const selectedVariant = variants.find(variant => variant.id == id);
      return selectedVariant;
    }

    addEventListeners(){
      const _this = this;
      this.quantity.addEventListener('updatequantity',function(event){ _this.updatePrice(event,_this); });
      this.variantSelect.addEventListener('updateVariant',function(event){ _this.updatePrice(event,_this); });
    }

    formatMoney(t, r) {
      function e(t, r) {
        return void 0 === t ? r : t;
      }
      function a(t, r, a, o) {
        if (r = e(r, 2),
        a = e(a, ","),
        o = e(o, "."),
        isNaN(t) || null == t)
        return 0;
        t = (t / 100).toFixed(r);
        var n = t.split(".");
        return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (n[1] ? o + n[1] : "");
      }
      "string" == typeof t && (t = t.replace(".", ""));
      var o = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      i = r || this.money_format;
      switch (i.match(n)[1]) {
        case "amount":
          o = a(t, 2);
          break;
        case "amount_no_decimals":
          o = a(t, 0);
          break;
        case "amount_with_comma_separator":
          o = a(t, 2, ".", ",");
          break;
        case "amount_with_space_separator":
          o = a(t, 2, " ", ",");
          break;
        case "amount_with_period_and_space_separator":
          o = a(t, 2, " ", ".");
          break;
        case "amount_no_decimals_with_comma_separator":
          o = a(t, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          o = a(t, 0, " ", "");
          break;
        case "amount_with_apostrophe_separator":
          o = a(t, 2, "'", ".");
          break;
        case "amount_with_decimal_separator":
          o = a(t, 2, ".", ".");}

      return i.replace(n, o);
    }

    updatePrice(event,fpp){
      const selectedVariant = fpp.getVariant(fpp.variantSelect.value);
      const newPrice = selectedVariant.price * fpp.quantity.value;
      const price = fpp.formatMoney(newPrice, fpp.moneyformat);
      fpp.innerHTML = price;
    }
  });
}
if (!customElements.get('fomo-gallery')) {
  customElements.define('fomo-gallery',class FomoProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.popup = this.querySelector('#gallery-zoom');
      this.targetImage = this.popup.querySelector('#target');
      this.close = this.popup.querySelector('#close');
      this.mainimages = this.querySelectorAll('.fomo-product-gallery img');
      this.images = this.querySelectorAll('.fomo-product-gallery-thumbnail-item img');
      this.addEventListeners();
    }

    addEventListeners(){
      const _this = this;
      this.close.addEventListener('click',function(event){ _this.closeModal(_this); });
      for(let i = 0, c = this.mainimages.length;i<c;i++){
        this.mainimages[i].addEventListener('click',function(event){ _this.openModal(event,_this); });
      }
      for(let i = 0, c = this.images.length;i<c;i++){
        this.images[i].addEventListener('click',function(event){ _this.openModal(event,_this); }); 
      }
    }

    openModal(event,_this){
      _this.targetImage.src = event.target.src;
      _this.popup.style.display = 'block';
    }
    
    closeModal(_this){
      _this.popup.style.display = 'none';
    }
  });
}

if (!customElements.get('fomo-gallery-product')) {
  customElements.define('fomo-gallery-product',class FomoProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.popup = this.querySelector('#gallery-zoom');
      this.targetImage = this.popup.querySelector('#target');
      this.close = this.popup.querySelector('#close');
      this.mainimages = this.querySelectorAll('.fomo-product-gallery img');
      this.images = [...this.querySelectorAll('.fomo-product-gallery-thumbnail-item img'),...this.querySelectorAll('.fomo-image-carousel-thumbnail img')];
      this.addEventListeners();
    }
    
    addEventListeners(){
      const _this = this;
      this.close.addEventListener('click',function(event){ _this.closeModal(_this); });
      for(let i = 0, c = this.mainimages.length;i<c;i++){
        this.mainimages[i].addEventListener('click',function(event){ _this.openModal(event,_this); });
      }
      for(let i = 0, c = this.images.length;i<c;i++){
        this.images[i].addEventListener('click',function(event){ _this.openModal(event,_this); }); 
      }
    }

    openModal(event,_this){
      const imageId = event.target.dataset.imageid;
      const image = _this.popup.querySelector(`img[data-imageid="${imageId}"]`);
      const container = _this.popup.querySelector('.zoom-image-container');
      _this.popup.style.display = 'block';
      container.scroll(0, -1 * container.topOffset);
      container.scroll(0, image.getBoundingClientRect().top);
    }
    
    closeModal(_this){
      _this.popup.style.display = 'none';
    }
  });
}

if (!customElements.get('fomo-image-carousel')) {
  customElements.define('fomo-image-carousel',class FomoImageCarousel extends HTMLElement {
    constructor() {
      super();
      this.left = 0;
      this.touchStartX = 0;
      this.buttonLeft = this.querySelector(".fomo-carousel-left");
      this.buttonRight = this.querySelector(".fomo-carousel-right");
      this.c = this.querySelector(".fomo-image-carousel-container");
      this.max = this.c.scrollWidth - this.c.offsetWidth;
      this.step = this.calculateStep();
      this.addEventListeners();
      this.refresh();
    }

    calculateStep(){
      const stepSize = Number(this.dataset.step);
      const steps = Math.floor(this.c.offsetWidth/stepSize);
      return stepSize * Math.floor(steps);
    }

    refresh(){
      this.buttonsEnabled = this.c.scrollWidth > this.c.offsetWidth;
      this.left = 0;
      this.updateButtons();
      this.setPostion();
    }

    updateButtons(){
      if(this.buttonsEnabled){
        this.buttonLeft.style.display = this.left == 0 ? "none" : "block";
        this.buttonRight.style.display = this.left == this.max ? "none" : "block";
      }
    }

    setPostion(){
      this.c.style.left = `-${this.left}px`;
    }

    addEventListeners(){
      const _this = this;
      this.buttonLeft.addEventListener('click',function(){_this.moveLeft(_this);});
      this.buttonRight.addEventListener('click',function(){_this.moveRight(_this);});

      _this.addEventListener('touchstart', function(event){_this.touchStart(event,_this);}, false);
      _this.addEventListener('touchmove', function(event){_this.touchMove(event,_this);}, false);
      _this.addEventListener('touchend', function(event){_this.touchEnd(event,_this);}, false);
    }

    touchStart(e,_this){
      _this.touchStartX = event.changedTouches[0].screenX;
      _this.updateButtons();
    }

    touchMove(e,_this){
      let pos = _this.left + (_this.touchStartX - event.changedTouches[0].screenX);
      if(pos < 0) pos = 0;
      else if(pos > _this.max) pos = _this.max;
      _this.left = pos;
      _this.setPostion();
      _this.updateButtons();
    }
                                                           
    touchEnd(e,_this){
      const val = _this.left + (_this.touchStartX - event.changedTouches[0].screenX);
      const multiplier = Math.ceil(val/this.step);
      let pos = (this.step * multiplier)
      if(left < 0) pos = 0;
      else if(left > _this.max) pos = _this.max;
      _this.left = pos;
      _this.setPostion();
    }

    moveLeft(_this){
      _this.left -= _this.step;
      if(_this.left < 0) _this.left = 0;
      _this.setPostion();
      _this.updateButtons();
    }
    
    moveRight(_this){
      _this.left += _this.step;
      if(_this.left > _this.max) this.left = _this.max;
      _this.setPostion();
      _this.updateButtons();
    }
  });
}
